/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import isUndefined from 'lodash.isundefined';

export const MAX_DEVICES = 500;
export const sizes = ['Bytes', 'KB', 'MB', 'GB'];

export const getESNs = (arr) => {
  return arr?.map(({esn}) => esn);
};

export const formatBytes = (bytes, decimals = 2) => {
  if (!isUndefined(bytes)) {
    if (bytes > 0) {
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
    return '0 Bytes';
  }
  return '';
};
